import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
  RouteRecordRaw
} from 'vue-router'
const ENV = require('../../env.js')()

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/GhostFestival.vue'),
    children: [
      {
        path: '',
        name: 'Home-Regulation',
        component: () => import('@/views/ghostFestival/Regulation.vue')
      },
      {
        path: 'Prize',
        name: 'Home-Prize',
        component: () => import('@/views/ghostFestival/Prize.vue'),
        children: [
          {
            path: '',
            name: 'Home-Prize-Point',
            component: () => import('@/views/ghostFestival/prize/Point.vue')
          },
          {
            path: 'Money',
            name: 'Home-Prize-Money',
            component: () => import('@/views/ghostFestival/prize/Money.vue')
          },
          {
            path: 'Coupon',
            name: 'Home-Prize-Coupon',
            component: () => import('@/views/ghostFestival/prize/Coupon.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import('@/views/Invoice.vue')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test.vue')
  }
]

const router = createRouter({
  history: createWebHistory(ENV.BASE_URL),
  routes
})

function hasQueryParams(route: RouteLocationNormalized) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name ?? 'Home', query: from.query })
  } else {
    next()
  }
})

export default router
